import { ReasonTypeEnum } from 'app/models/enums/reason-type.enum';

export class ReasonModel {
	public static ReasonList: Array<any> = [
		{ value: ReasonTypeEnum.All, name: 'All' },
		{ value: ReasonTypeEnum.PassengerNoShow, name: 'Passenger No Show' },
		{ value: ReasonTypeEnum.PassengerIsWithChild, name: 'Passenger is with a child' },
		{ value: ReasonTypeEnum.TooManyPassengersOrLuggage, name: 'Too many passengers or luggage' },
		{ value: ReasonTypeEnum.CreatePaymentFailed, name: 'Create Payment Failed' },
		{ value: ReasonTypeEnum.Accident, name: 'Accident' },
		{ value: ReasonTypeEnum.DoubleBooking, name: 'Double booking' },
		{ value: ReasonTypeEnum.PassengerChangedMind, name: 'Passenger changed mind' },
		{ value: ReasonTypeEnum.PassengerHasDesignated, name: 'Passenger has a designated' },
		{ value: ReasonTypeEnum.NoSignal, name: 'No Signal' },
		{ value: ReasonTypeEnum.WrongPin, name: 'Wrong Pin' },
		{ value: ReasonTypeEnum.GrayButtonCantSwipe, name: 'Gray Button Can\'t Swipe' },
		{ value: ReasonTypeEnum.LowBattery, name: 'Low Battery' },
		{ value: ReasonTypeEnum.Other, name: 'Other' }
	];
}
